import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import FacebookLikeIcon from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/social/FacebookLike';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export const FacebookLikeIconStyled = styled(FacebookLikeIcon)`
  ${({ theme }) => {
    return css`
      color: ${theme.colors.blue.blue};
    `;
  }}
`;

export const LabelFafaPollStyled = styled.label`
  background-color: transparent;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: ${rem(40)} ${rem(4)} 0;
  margin: 0 ${rem(10)};
  height: ${rem(50)};
  cursor: pointer;
`;

export const InputRadioStyled = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  opacity: 0;
`;

export const TypographyLabelStyled = styled(Typography)`
  padding: 0;
`;

export const DivIconContainerStyled = styled.div`
  ${({ inverted }) => {
    return css`
      margin-right: ${rem(10)};
      ${inverted && 'transform: rotate(180deg);'};
    `;
  }}
`;

export const TypographyThankYouStyled = styled(Typography)`
  padding: ${rem(48)} 0;
`;
